import React from 'react'

import { useIntl } from 'react-intl'

import Stack from 'app/components/base/Stack'
import Text from 'app/components/base/Text'
import BidButton from 'app/components/buttons/BidButton'
import SetMaxBidButton from 'app/components/buttons/SetMaxBidButton'
import WatchButton from 'app/components/buttons/WatchButton'
import BidHistory from 'app/features/ListingFeature/components/BidHistory'
import { IS_NATIVE_APP } from 'app/utils/constants/env.constants'

import ReserveInfo from './ReserveInfo'

interface AuctionActionsProps {
  auctionId: number
  bidsCount: number
  auctionReserveStatus?: string
  currency: string
  disabled?: boolean
  inWatchList?: boolean
  watchListId?: string
  exchangeRate?: number
  maxBid?: MaxBidModel
}

const AuctionActions: RFC<AuctionActionsProps> = ({
  auctionId,
  bidsCount,
  auctionReserveStatus,
  currency,
  disabled,
  inWatchList,
  watchListId,
  exchangeRate,
  maxBid
}) => {
  const { formatMessage, formatNumber } = useIntl()
  const isYourMaxBid = !!maxBid?.price

  return (
    <Stack direction="row" spacing={1.5} sx={{ width: '100%' }}>
      <Stack spacing={0.75} sx={{ flex: 1 }}>
        <Stack spacing={1} direction="row" alignItems="center">
          <BidButton
            auctionId={auctionId}
            currency={currency}
            disabled={disabled}
            exchangeRate={exchangeRate}
            {...(isYourMaxBid && { sx: { maxWidth: '150px', p: 0 } })}
          />

          {isYourMaxBid ? (
            <Stack
              spacing={{ xs: 0, md: 0.5 }}
              {...(!IS_NATIVE_APP && {
                direction: { xs: 'column', md: 'row' }
              })}
            >
              <Text variant="body1">
                {formatMessage({ defaultMessage: 'Your Max Bid' })}
              </Text>
              <Text variant="body1">
                {formatNumber(maxBid.price, { style: 'currency', currency })}
              </Text>
            </Stack>
          ) : (
            <SetMaxBidButton
              auctionId={auctionId}
              currency={currency}
              disabled={disabled}
              exchangeRate={exchangeRate}
            />
          )}
        </Stack>

        <ReserveInfo reserveStatus={auctionReserveStatus} />
      </Stack>

      <Stack spacing={0.75} sx={{ alignItems: 'center' }}>
        <WatchButton
          auctionId={auctionId}
          isActive={inWatchList}
          watchListId={watchListId}
        />

        <BidHistory
          auctionId={auctionId}
          bidsCount={bidsCount}
          currency={currency}
        />
      </Stack>
    </Stack>
  )
}

export default AuctionActions
